<template>
    <div class="orderDetail_wrap">
        <div class="breadBox">
            <el-button @click="back" class="backBtn"><i class="el-icon-arrow-left"></i> 返回</el-button>
            <div class="breadItem"><span>订单管理</span></div>
            <div class="breadItem"><span>订单列表</span></div>
            <div class="breadItem"><span>订单详情</span></div>
        </div>
        <div class="content">
            <!-- 第一块 订单概况 -->
            <div class="panelBox">
                <div class="panelTitle">
                    <div class="inner">订单概况</div>
                </div>
                <div class="panelContent flex first">
                    <div class="headerImg">
                        <viewer :images="infoObj.imageObj.positiveImg" > 
                            <img
                                v-for="(list, index) in infoObj.imageObj.positiveImg"
                                :src="IMG_PREV+list.image_file"
                                :key="index"
                            >
                        </viewer>
                        <!-- <img :src="IMG_PREV+list.image_file" alt="" v-for="(list,index) in infoObj.imageObj.positiveImg" :key="index" @click="prevImg(list.image_file)"> -->
                    </div>
                    <div class="rightBox">
                        <div class="firstLine">
                            <div class="textBox">
                                <span class="title">{{infoObj.orderName}}</span>
                                <span class="status blue">{{infoObj.orderStatus |turnValToText("order_status")}}</span>
                            </div>
                           
                        </div>
                        <div class="normalLine">
                            <div class="oneItem">
                               <p class="label">订单编号</p>
                               <p class="text">{{infoObj.orderNumber}}</p>
                            </div>
                            <div class="oneItem">
                               <p class="label">款式分类</p>
                               <p class="text">{{infoObj.orderStyleMemo}}</p>
                            </div>
                            <div class="oneItem">
                               <p class="label">订单类型</p>
                               <p class="text">{{infoObj.orderType |turnValToText("order_type")}}</p>
                            </div>
                        </div>
                        <div class="normalLine">
                            <div class="oneItem">
                               <p class="label">订单数量</p>
                               <p class="text">{{infoObj.orderQuantity}} 件</p>
                            </div>
                            <div class="oneItem">
                               <p class="label">单价</p>
                               <p class="text">{{infoObj.orderUnitPrice}} 元</p>
                            </div>
                            <div class="oneItem">
                               <p class="label">交货日期</p>
                               <p class="text">{{infoObj.orderDeliveryTime}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 第一块  订单进度-->
            <div class="panelBox">
                <div class="panelTitle">
                    <div class="inner">订单进度 
                        <el-button type="primary" class="edit-progress-btn" @click="toEditProgress" v-if="functionEditOrderProgress">编辑进度</el-button>
                    </div>
                </div>
                <div class="panelContent progress">
                    <div class="progress-item">
                        <div class="progress-item-title"><i class="el-icon-time"></i> <span>发单方</span></div>
                        <el-timeline>
                            <el-timeline-item
                                v-for="(item, i) in fdOrderDynamics"
                                :key="i"
                                :timestamp="item.record_time"
                            >
                                <span v-for="(ele, j) in item.log_text.text" :key="j" :class="{'active-text':ele.type=='button'}" @click="seeDynamicsDetail(ele.link)">{{ele.str}}</span>
                                <i v-if="item.isAdmin" class="el-icon-user-solid admin-flag" title="管理员操作"></i>
                            </el-timeline-item>
                        </el-timeline>
                        <div class="no-dynamics" v-if="fdOrderDynamics.length == 0"> <i class="el-icon-document"></i> 暂无进度</div>
                    </div>
                    <div class="progress-item">
                        <div class="progress-item-title"><i class="el-icon-time"></i> <span>接单方<small>（经发单方确认）</small></span></div>
                        <el-timeline>
                            <el-timeline-item
                                v-for="(item, index) in jdOrderDynamics"
                                :key="index"
                                :timestamp="item.record_time"
                            >
                                <span v-for="(ele, j) in item.log_text.text" :key="j" :class="{'active-text':ele.type=='button'}" @click="seeDynamicsDetail(ele.link)">{{ele.str}}</span>
                                <i v-if="item.isAdmin" class="el-icon-user-solid admin-flag" title="管理员操作"></i>  
                            </el-timeline-item>
                        </el-timeline>
                        <div class="no-dynamics" v-if="jdOrderDynamics.length == 0"><i class="el-icon-document"></i>暂无进度</div>
                    </div>
                    
                   
                </div>
            </div>
            
            <!-- 第2块 -->
            <div class="brandFactoryPart">
                <div class="left">
                    <div class="panelBox">
                      <div class="panelTitle"><div class="inner">发单品牌商</div></div>
                      <div class="panelContent  second">
                          <div class="factoryWrap" >
                              <div class="factoryTitle active">
                                  {{fadanfangObj.fadanfangInfo.company_name}}
                                  <div class="choseTag" @click="toFadanDetail">查看</div>
                              </div>
                              <div class="factoryDetail">
                                  <div class="oneItem">
                                      <div class="label">地址</div>
                                      <div class="text">
                                        <span class="itemSpan">{{fadanfangObj.fadanfangInfo.company_province}}</span>
                                        <span class="itemSpan">{{fadanfangObj.fadanfangInfo.company_city}}</span>
                                        <span class="itemSpan">{{fadanfangObj.fadanfangInfo.company_district}}</span>
                                      </div>
                                  </div>
                                   <div class="oneItem" v-if="fadanfangObj.regStr.channel&&fadanfangObj.regStr.channel.list">
                                      <div class="label">营销渠道</div>
                                      <div class="text" >
                                          <span class="itemSpan" v-for="list in fadanfangObj.regStr.channel.list" v-if="list.isSelect==1">{{list.dataName}}</span>
                                      </div>
                                  </div>
                                   <div class="oneItem">
                                      <div class="label">主营品类</div>
                                      <div class="text shengluehao" >
                                          <span class="itemSpan" v-for="list1 in fadanfangObj.regStr.product"  v-if="list1.checked==true">{{list1.dataName}}:
                                            <span class="itemSpan" v-for="list2 in list1.list" v-if="list2.checked==true"> {{list2.name}} </span>
                                          </span>
                    
                                      </div>
                                  </div>
                              </div>
                              
                          </div>
                          
                          
                      </div>
                    </div>
                </div>
                <div class="right">
                    <!-- 第2块de 生产商 -->
                    <div class="panelBox">
                        <div class="panelTitle"><div class="inner">接单生产商</div></div>
                        <div class="panelContent  second">
                           <!-- <el-carousel :interval="5000" arrow="always">
                                <el-carousel-item v-for="item in 4" :key="item">
                                  <h3>{{ item }}</h3>
                                </el-carousel-item>
                            </el-carousel> -->
                            <div class="factoryWrap"  v-for="list in jiedanfangArr" v-if="jiedanfangArr.length>0">
                                <div class="factoryTitle active">
                                    {{list.company_name}} 
                                    <div class="choseTag" @click="toJiedanDetail(list)">查看</div>
                                </div>
                                <div class="factoryDetail">
                                    <div class="oneItem">
                                        <div class="label">地址</div>
                                        <div class="text">{{list.company_province}} {{list.company_city}} {{list.company_district}}</div>
                                    </div>
                                    <div class="oneItem">
                                        <div class="label">主要品质</div>
                                        <div class="text" v-if="list&&list.staffDevice&&list.staffDevice.mainQuantityStr">
                                            <span class="itemSpan" v-for="list2 in list.staffDevice.mainQuantityStr.list" v-if="list2.isSelect==1">
                                                {{list2.dataName}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="oneItem">
                                        <div class="label">擅长工艺</div>
                                        <div class="text" v-if="list&&list.staffDevice&&list.staffDevice.handleNeedProcessingLink">
                                             <span class="itemSpan" v-for="list3 in list.staffDevice.handleNeedProcessingLink.list" v-if="list3.isSelect==1">
                                                {{list3.dataName}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            
                            
                        </div>
                    </div>
                    
                </div>
            </div>
            <!-- 第3块 -->
            <div class="panelBox" v-if="addInfoObj.isShow">
                <div class="panelTitle"><div class="inner">补充资料</div></div>
                <div class="panelContent third">
                    <div class="line ">
                         <div class="oneItem three">
                            <div class="label">查货方式说明</div>
                            <div class="text">
                                <viewer :images="addInfoObj.checkGoodsImg" > 
                                    <img
                                        v-for="(list, index) in addInfoObj.checkGoodsImg"
                                        :src="IMG_PREV+list.image_file"
                                        :key="index"
                                    >
                                </viewer>
                                <!-- <img :src="IMG_PREV+list.image_file" alt="" v-for="(list,index) in addInfoObj.checkGoodsImg" @click="prevImg(list.image_file)"> -->
                            </div>
                        </div>
                        <div class="oneItem three">
                            <div class="label">工艺单</div>
                            <div class="text">
                                <viewer :images="addInfoObj.technologyImg" > 
                                    <img
                                        v-for="(list, index) in addInfoObj.technologyImg"
                                        :src="IMG_PREV+list.image_file"
                                        :key="index"
                                    >
                                </viewer>
                                 <!-- <img :src="IMG_PREV+list.image_file" alt="" v-for="(list,index) in addInfoObj.technologyImg" @click="prevImg(list.image_file)"> -->
                            </div>
                        </div>
                        <div class="oneItem three">
                            <div class="label">尺码表</div>
                            <div class="text">
                                <viewer :images="addInfoObj.sizeTableImg" > 
                                    <img
                                        v-for="(list, index) in addInfoObj.sizeTableImg"
                                        :src="IMG_PREV+list.image_file"
                                        :key="index"
                                    >
                                </viewer>
                                <!-- <img :src="IMG_PREV+list.image_file" alt="" v-for="(list,index) in addInfoObj.sizeTableImg" @click="prevImg(list.image_file)"> -->
                            </div>
                        </div>
                    </div>
                    <div class="line">
                        <div class="oneItem half">
                            <div class="label">查货方式</div>
                            <div class="text">
                                {{addInfoObj.selfTestMethod}}
                            </div>
                        </div>
                        <div class="oneItem half">
                            <div class="label">查货比例</div>
                            <div class="text">
                               {{addInfoObj.proportionOfInspection}}%
                            </div>
                        </div>
                    </div>
                     <div class="line">
                        <div class="oneItem three">
                            <div class="label">质检要求</div>
                            <div class="text">
                                {{addInfoObj.qualityInspectionRequirements}}
                            </div>
                        </div>
                         <div class="oneItem three">
                            <div class="label">生产商自检要求</div>
                            <div class="text">
                                {{addInfoObj.manufacturerSelfTestRequirements}}
                            </div>
                        </div>
                         <div class="oneItem three">
                            <div class="label">发单方自检要求</div>
                            <div class="text">
                                {{addInfoObj.inspectionMethod}}
                            </div>
                        </div>
                         <div class="oneItem three">
                            <div class="label">第三方检查要求</div>
                            <div class="text">
                                {{addInfoObj.thirdPartyInspectionRequirements}}
                            </div>
                        </div>
                    </div>
                    <div class="line last">
                        <div class="oneItem">
                            <div class="label">补充备注</div>
                            <div class="text">
                                {{addInfoObj.additionalMaterialsRemark}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 第4块 详情-->
            <div class="panelBox">
                <div class="panelTitle"><div class="inner">订单详情</div></div>
                <div class="panelContent fourth">
                    <div class="oneBlock">
                        <div class="blockTitle"> 
                            <span>支付信息</span> 
                            <span class="blue">该订单报价为{{payInfoStr.order_is_include_tax == 'y' ? '含税' : '不含税'}}报价</span>
                        </div>
                        <div class="blockContent">
                            <div class="line">
                                <div class="oneItem three">
                                    <div class="label">预付款</div>
                                    <div class="text">¥ {{payInfoStr.orderAdvancePayment}}元 ({{payInfoStr.order_advance_payment_percent}}%)     </div>
                                </div>
                                <div class="oneItem three">
                                    <div class="label">交货款</div>
                                    <div class="text">¥ {{payInfoStr.orderDeliveryPayment}}元 ({{payInfoStr.order_delivery_payment_percent}}%)</div>
                                </div>
                                <div class="oneItem three">
                                    <div class="label">尾款/质保金</div>
                                    <div class="text"> ¥ {{payInfoStr.tailMoney}}元  ({{payInfoStr.tail_money_pecent}}%)    </div>
                                </div>
                            </div>
                             <div class="line">
                                <div class="oneItem three">
                                    <div class="label">总金额</div>
                                    <div class="text"> ¥ {{payInfoStr.order_total_price}}    </div>
                                </div>
                                <div class="oneItem three">
                                    <div class="text"> 请注意付款的时间阶段和对应比例    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="oneBlock">
                        <div class="blockTitle"> <span>基础资料</span> </div>
                        <div class="blockContent">
                             <div class="line">
                                <div class="oneItem three">
                                    <div class="label">需要生产商制作</div>
                                    <div class="text"> 
                                        <span class="itemSpan" v-for="(item, index) in needProducerDo.listStr" >{{item}}</span>
                                        <span class="itemSpan">{{needProducerDo.other}}</span>
                                    </div>
                                </div>
                                <div class="oneItem three">
                                    <div class="label">品质要求</div>
                                    <div class="text"> {{infoObj.quantityStr}}   </div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="oneItem three">
                                    <div class="label">需要加工的环节</div>
                                    <div class="text"> 
                                        <span class="itemSpan" v-for="(item, index) in needProcessingLink.listStr" >{{item}}</span>
                                        <span class="itemSpan">{{needProcessingLink.other}}</span>
                                    </div>
                                </div>
                                 <div class="oneItem three">
                                    <div class="label">特殊工艺</div>
                                    <div class="text"> 
                                        <span class="itemSpan" v-for="(item, index) in specialProcess.listStr" >{{item}}</span>
                                        <span class="itemSpan">{{specialProcess.other}}</span>
                                    </div>
                                </div>
                            </div>
                             <div class="line">
                                <div class="oneItem ">
                                    <div class="label">品牌商提供的资料</div>
                                     <div class="text"> 
                                        <span class="itemSpan" v-for="(item, index) in needInfomation.listStr" >{{item}}</span>
                                        <span class="itemSpan">{{needInfomation.other}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="oneBlock">
                        <div class="blockTitle"> <span>交货信息</span> </div>
                        <div class="blockContent">
                            <div class="line">
                                <div class="oneItem three">
                                    <div class="label">预计面辅料到期时间</div>
                                    <div class="text"> {{deliveryInformation.order_material_ready_time}}    </div>
                                </div>
                                <div class="oneItem three">
                                    <div class="label">交货方式</div>
                                    <div class="text"> {{deliveryInformation.deliveryMethod}}    </div>
                                </div>
                            </div>
                             <div class="line">
                                <div class="oneItem three">
                                    <div class="label">大货运费承担方</div>
                                    <div class="text"> {{deliveryInformation.highFreightChargeBearer}}</div>
                                </div>
                                <div class="oneItem three">
                                    <div class="label">面辅料运费承担方</div>
                                    <div class="text"> {{deliveryInformation.fabricFreightChargeBearer}}   </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="oneBlock">
                        <div class="blockTitle"> <span>联系方式</span> </div>
                        <div class="blockContent">
                            <div class="line">
                                <div class="oneItem three">
                                    <div class="label">品牌商联系方式</div>
                                    <div class="text">
                                            <div>{{contactInfoObj.address_contact_name}} {{contactInfoObj.address_contact_phone}}</div>
                                            <div>{{contactInfoObj.address}}</div>
                                    </div>
                                </div>
                                <div class="oneItem three">
                                    <div class="label">生产商联系方式</div>
                                    <div class="text">
                                            <div>{{shengchanAddressInfo.address_contact_name}} {{shengchanAddressInfo.address_contact_phone}}</div>
                                            <div>{{shengchanAddressInfo.address}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="oneBlock">
                        <div class="blockContent">
                            <div class="line">
                                <div class="oneItem ">
                                    <div class="label">颜色-尺码-数量</div>
                                    <div class="text">
                                        <!-- <el-table  stripe :data="colorSizeGroup.group" tooltip-effect="dark" style="width: 100%">
                                        	<el-table-column   align="right" width="150" v-for="(list,index) in colorSizeGroup.group">
                                        	      <template slot="header" slot-scope="scope">
                                                    {{list.color}}
                                        	      </template>
                                        	      <template slot-scope="scope">
                                                      <span v-for="(list2,index2) in list.sizeArr">
                                                          {{list2.name}}: {{list2.number}}
                                                      </span>
                                        	      </template>
                                        	</el-table-column>
                                        	
                                        </el-table> -->
                                        <div class="sizeColorTable">
                                            <div class="tableCol" v-for="list in colorSizeData ">
                                               <div class="colLabel">{{list.color}}</div>
                                               <div class="num" v-for="listSize in list.sizeArr">
                                                   <span v-if="list.color=='尺码'">{{listSize.name}}</span>
                                                   <span v-if="list.color!='尺码'">{{listSize.number}}</span>
                                                    
                                               </div>
                                               <div class="total">
                                                   <span>{{list.sum}}</span>
                                               </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="oneBlock">
                        <div class="blockContent">
                            <div class="line">
                                <div class="oneItem ">
                                    <div class="label">样式说明</div>
                                    <div class="text">
                                        <div>{{infoObj.styleDes}} </div>
                                        <div>
                                            <viewer :images="styleImgsArr" > 
                                                <img
                                                    v-for="(list, index) in styleImgsArr"
                                                    :src="IMG_PREV+list.image_file"
                                                    :key="index"
                                                >
                                            </viewer>
                                            <!-- <img :src="IMG_PREV+list.image_file" alt="" v-for="(list,index) in infoObj.imageObj.positiveImg" @click="prevImg(list.image_file)">
                                            <img :src="IMG_PREV+list.image_file" alt="" v-for="(list,index) in infoObj.imageObj.negativeImg" @click="prevImg(list.image_file)">
                                            <img :src="IMG_PREV+list.image_file" alt="" v-for="(list,index) in infoObj.imageObj.detailsImg" @click="prevImg(list.image_file)"> -->
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="oneBlock">
                        <div class="blockContent" v-for="(list,index) in fabricInformationStr.group">
                            <div class="line">
                                <div class="oneItem three">
                                    <div class="label">面料{{index+1}}名称</div>
                                    <div class="text">{{list.name}} </div>
                                </div>
                                 <div class="oneItem three">
                                    <div class="label">门幅宽度</div>
                                    <div class="text">{{list.doorWidth}} </div>
                                </div>
                                 <div class="oneItem three">
                                    <div class="label">单件用量</div>
                                    <div class="text">{{list.estimateUsage}}米 </div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="oneItem three">
                                    <div class="label">缩率</div>
                                    <div class="text">{{list.reduceRatio}}% </div>
                                </div>
                                 <div class="oneItem three">
                                    <div class="label">是否需要复合</div>
                                    <div class="text">
                                        <span v-if="list.recombination==1">是</span>
                                        <span v-if="list.recombination!=1">否</span>
                                    </div>
                                </div>
                                 <div class="oneItem three">
                                    <div class="label">是否需要水洗</div>
                                    <div class="text">
                                        <span  v-if="list.washing==1">是</span>
                                        <span  v-if="list.washing!=1">否</span>
                                        
                                    </div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="oneItem three">
                                    <div class="label">是否需要缩水</div>
                                    <div class="text">
                                       <span v-if="list.shrink==1">是</span>
                                       <span v-if="list.shrink!=1">否</span>
                                    </div>
                                </div>
                                 <div class="oneItem two">
                                    <div class="label">面辅料图片</div>
                                    <div class="text">
                                        <viewer :images="list.imageJson[0] && [...list.imageJson[0].fabricImgs, ...list.imageJson[0].fabricParamImgs]" > 
                                            <img
                                                v-for="(list2, index) in list.imageJson[0] && [...list.imageJson[0].fabricImgs, ...list.imageJson[0].fabricParamImgs]"
                                                :src="list2?IMG_PREV+list2.image_file:''"
                                                :key="index"
                                            >
                                        </viewer>
                                        <!-- <img :src="IMG_PREV+list2.image_file" alt="" v-for="(list2,index2) in list.imageJson[0]&&list.imageJson[0].fabricImgs" @click="prevImg(list2.image_file)">
                                        <img :src="IMG_PREV+list2.image_file" alt="" v-for="(list2,index2) in list.imageJson[0]&&list.imageJson[0].fabricParamImgs" @click="prevImg(list2.image_file)"> -->
                                    </div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="oneItem">
                                    <div class="label">辅料</div>
                                    <div class="text">
                                        <span  class="itemSpan" v-for="(list,index) in fabricInformationStr.excipient.list" v-if="list.isSelect==1">{{list.dataName}}</span>
                                        <span class="itemSpan">{{fabricInformationStr.excipient.other}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="oneItem">
                                    <div class="label">面辅料补充说明</div>
                                    <div class="text">{{fabricInformationStr.supplementInfo}} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="oneBlock">
                        <div class="blockContent">
                            <div class="line">
                                <div class="oneItem ">
                                    <div class="label">备注</div>
                                    <div class="text">
                                        <div>意向订单备注:  {{infoObj.intentionalOrderRemark}}</div>
                                        <div>补充备注： {{addInfoObj.additionalMaterialsRemark}}</div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <el-dialog	custom-class="prevImgModal"  title="图片预览"	center	  :visible.sync="isShowImgModal"	top="3vh"  >
          <div class="prevImgModalContent">		  <img :src="IMG_PREV+currentPrevImg" alt="" >		  </div>
          <span slot="footer" class="dialog-footer">
        	<el-button type="primary" @click="isShowImgModal = false">关闭</el-button>
          </span>
        </el-dialog>

        <!-- ================================ 订单动态 - 查看详情 =========================================== -->
        <!-- 查看合同 -->
        <el-dialog 
            title="查看合同"
            :visible.sync="seeContractShow"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的合同图片或扫描件：">
                    <viewer :images="seeContract.contractRemarkImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeContract.contractRemarkImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeContract.contractRemarkImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeContract.contractRemarkImg && seeContract.contractRemarkImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="合同备注：">
                    <span>{{seeContract.contractRemark ? seeContract.contractRemark : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="管理员备注信息：" v-if="seeContract.contractAdminRemark">
                    <span>{{seeContract.contractAdminRemark ? seeContract.contractAdminRemark : '未填写'}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seeContractShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看定金支付凭证 -->
        <el-dialog 
            title="查看定金支付凭证"
            :visible.sync="seePayAdvanceVoucherShow" 
        >
            <el-form label-width="180px">
                <el-form-item label="上传的支付凭证图片：">
                    <viewer :images="seePayAdvanceVoucher.paymentRemarkImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seePayAdvanceVoucher.paymentRemarkImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seePayAdvanceVoucher.paymentRemarkImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seePayAdvanceVoucher.paymentRemarkImg && seePayAdvanceVoucher.paymentRemarkImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <span>{{seePayAdvanceVoucher.prepaymentRemark ? seePayAdvanceVoucher.prepaymentRemark : '未填写'}}</span>
                </el-form-item>
                <el-form-item label="管理员备注信息：" v-if="seePayAdvanceVoucher.prepaymentAdminRemark">
                    <span>{{seePayAdvanceVoucher.prepaymentAdminRemark ? seePayAdvanceVoucher.prepaymentAdminRemark : '未填写'}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seePayAdvanceVoucherShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看大货（成衣） -->
        <el-dialog 
            title="查看大货（成衣）"
            :visible.sync="seeGoodsShow"
        >
            <el-form label-width="180px">
                <el-form-item label="交付大货件数：">
                    <span>{{seeGoods.deliverQuantity ? seeGoods.deliverQuantity : '未填写'}}</span>
                </el-form-item>
                <el-form-item label="上传的支付凭证图片：">
                    <viewer :images="seeGoods.deliverImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeGoods.deliverImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeGoods.deliverImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeGoods.deliverImg && seeGoods.deliverImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <span>{{seeGoods.deliverDescription ? seeGoods.deliverDescription : '未填写'}}</span>
                </el-form-item>
                <el-form-item label="管理员备注信息：" v-if="seeGoods.deliverLargeGoodsAdminRemark">
                    <span>{{seeGoods.deliverLargeGoodsAdminRemark ? seeGoods.deliverLargeGoodsAdminRemark : '未填写'}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seeGoodsShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看验收结果 -->
        <el-dialog 
            title="查看验收结果"
            :visible.sync="seeResultShow"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的图片：">
                    <viewer :images="seeResult.acceptanceImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeResult.acceptanceImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeResult.acceptanceImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeResult.acceptanceImg && seeResult.acceptanceImg.length == 0">未上传图片</span>
                </el-form-item>

                <el-form-item label="不合格数量：">
                    <span>{{seeResult.quantity == '' ? '--' : seeResult.quantity}} 件</span>
                </el-form-item>

                <el-form-item label="总数：">
                    <span>{{seeResult.goodsTotal== '' ? '--' : seeResult.goodsTotal}} 件</span>
                </el-form-item>

                <el-form-item label="不合格占比：">
                    <span>{{seeResult.rejectRatio == '' ? '--' : seeResult.rejectRatio}} %</span>
                </el-form-item>

                <el-form-item label="备注说明：">
                    <span>{{seeResult.description ? seeResult.description : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="管理员备注信息：" v-if="seeResult.submitAcceptanceResultsAdminRemark">
                    <span>{{seeResult.submitAcceptanceResultsAdminRemark ? seeResult.submitAcceptanceResultsAdminRemark : '未填写'}}</span>
                </el-form-item>

                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seeResultShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看交货款支付凭证 -->
        <el-dialog 
            title="查看交货款支付凭证"
            :visible.sync="seePayDeliveryVoucherShow"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的支付凭证图片：">
                    <viewer :images="seePayDeliveryVoucher.deliveryRemarkImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seePayDeliveryVoucher.deliveryRemarkImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seePayDeliveryVoucher.deliveryRemarkImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seePayDeliveryVoucher.deliveryRemarkImg && seePayDeliveryVoucher.deliveryRemarkImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <span>{{seePayDeliveryVoucher.deliveryRemark ? seePayDeliveryVoucher.deliveryRemark : '未填写'}}</span>
                </el-form-item>
                <el-form-item label="管理员备注信息：" v-if="seePayDeliveryVoucher.deliveryAdminRemark">
                    <span>{{seePayDeliveryVoucher.deliveryAdminRemark ? seePayDeliveryVoucher.deliveryAdminRemark : '未填写'}}</span>
                </el-form-item>
                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seePayDeliveryVoucherShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看尾款支付凭证 -->
        <el-dialog 
            title="查看尾款支付凭证"
            :visible.sync="seePayTailVoucherShow"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的支付凭证图片：">
                    <viewer :images="seePayTailVoucher.tailRemarkImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seePayTailVoucher.tailRemarkImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seePayTailVoucher.tailRemarkImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seePayTailVoucher.tailRemarkImg && seePayTailVoucher.tailRemarkImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <span>{{seePayTailVoucher.tailRemark ? seePayTailVoucher.tailRemark : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="管理员备注信息：" v-if="seePayTailVoucher.tailAdminRemark">
                    <span>{{seePayTailVoucher.tailAdminRemark ? seePayTailVoucher.tailAdminRemark : '未填写'}}</span>
                </el-form-item>

                
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seePayTailVoucherShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看评价 -->
        <el-dialog 
            title="查看评价"
            :visible.sync="seeCommentShow"
        >
            <el-form label-width="100px">
                <div style="margin-bottom: 20px">品牌商对生产商评价：</div>
                <el-form-item label="评分：">
                    <el-rate
                        v-model="seeComment.comment_score"
                        show-score
                        disabled
                        text-color="#ff9900"
                    >
                    </el-rate>
                </el-form-item>
                <el-form-item label="评语：">
                    <span>{{seeComment.comment_info ? seeComment.comment_info : '未填写'}}</span>
                </el-form-item>
                <div style="margin-bottom: 20px">品牌商对生产商评价：</div>
                <el-form-item label="评分：">
                    <el-rate
                        v-model="seeComment.producer_comment_score"
                        show-score
                        disabled
                        text-color="#ff9900"
                    >
                    </el-rate>
                </el-form-item>
                <el-form-item label="评语：">
                    <span>{{seeComment.producer_comment_info ? seeComment.producer_comment_info : '未填写'}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seeCommentShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看取消原因（生产商取消） -->
        <el-dialog 
            title="查看取消原因"
            :visible.sync="seeProducerCancelReasonShow"
        >
            <el-form label-width="180px">
                <el-form-item label="上传的支付凭证图片：">
                    <viewer :images="seeProducerCancelReason.producerCancelImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeProducerCancelReason.producerCancelImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeProducerCancelReason.producerCancelImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeProducerCancelReason.producerCancelImg && seeProducerCancelReason.producerCancelImg.length == 0">未上传图片</span>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <span>{{seeProducerCancelReason.producerCancellationOfOrder ? seeProducerCancelReason.producerCancellationOfOrder : '未填写'}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="seeProducerCancelReasonShow = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 查看补充资料 -->
        <el-dialog 
            title="查看补充资料"
            :visible.sync="seeAdditionalDataShow"
        >
            <el-form label-width="180px">
                <el-form-item label="工艺单图片：">
                    <viewer :images="seeAdditionalData.technologyImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeAdditionalData.technologyImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeAdditionalData.technologyImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeAdditionalData.technologyImg && seeAdditionalData.technologyImg.length == 0">未上传图片</span>
                </el-form-item>

                <el-form-item label="尺码表图片：">
                    <viewer :images="seeAdditionalData.sizeTableImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeAdditionalData.sizeTableImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeAdditionalData.sizeTableImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeAdditionalData.sizeTableImg && seeAdditionalData.sizeTableImg.length == 0">未上传图片</span>
                </el-form-item>

                <el-form-item label="查货方式图片：">
                    <viewer :images="seeAdditionalData.checkGoodsImg" > 
                        <img
                            style="width： 100px; height: 100px; margin-right: 10px;"
                            v-for="(url, index) in seeAdditionalData.checkGoodsImg"
                            :src="url.image_file"
                            :key="index"
                        >
                    </viewer>
                    <!-- <el-image v-for="(url, index) in seeAdditionalData.checkGoodsImg" :key="index" :src="url.image_file" @click.native="handlePictureCardPreview(url)" style="width: 100px; height: 100px"></el-image> -->
                    <span v-if="seeAdditionalData.checkGoodsImg && seeAdditionalData.checkGoodsImg.length == 0">未上传图片</span>
                </el-form-item>

                <el-form-item label="查货方式：">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.inspectionMethod ? seeAdditionalData.orderAdditionalMaterials.inspectionMethod : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="查货比例：" v-if="seeAdditionalData.orderAdditionalMaterials.inspectionMethod == '发单方自检'">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.proportionOfInspection ? seeAdditionalData.orderAdditionalMaterials.proportionOfInspection + '%' : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="发单方自检方式：" v-if="seeAdditionalData.orderAdditionalMaterials.inspectionMethod == '发单方自检'">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.selfTestMethod ? seeAdditionalData.orderAdditionalMaterials.selfTestMethod : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="质检要求：" v-if="seeAdditionalData.orderAdditionalMaterials.inspectionMethod == '发单方自检'">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.qualityInspectionRequirements ? seeAdditionalData.orderAdditionalMaterials.qualityInspectionRequirements : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="生产商自检要求：" v-if="seeAdditionalData.orderAdditionalMaterials.inspectionMethod == '生产商自检'">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.manufacturerSelfTestRequirements ? seeAdditionalData.orderAdditionalMaterials.manufacturerSelfTestRequirements : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="第三方检查要求：" v-if="seeAdditionalData.orderAdditionalMaterials.inspectionMethod == '第三方检查'">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.thirdPartyInspectionRequirements ? seeAdditionalData.orderAdditionalMaterials.thirdPartyInspectionRequirements : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="补充备注：">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.additionalMaterialsRemark ? seeAdditionalData.orderAdditionalMaterials.additionalMaterialsRemark : '未填写'}}</span>
                </el-form-item>

                <el-form-item label="管理员备注信息：" v-if="seeAdditionalData.orderAdditionalMaterials.additionalMaterialsAdminRemark">
                    <span>{{seeAdditionalData.orderAdditionalMaterials.additionalMaterialsAdminRemark ? seeAdditionalData.orderAdditionalMaterials.additionalMaterialsAdminRemark : '未填写'}}</span>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="seeAdditionalDataShow = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 图片预览弹框 -->
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>

    </div>
</template>

<script>
    import {        json,        wordData,        utils    } from '@/common/common.js'
    import {        ajaxPost,        api    } from '@/common/request.js'
    import {        ajaxApp    } from '@/common/request_app.js'
    
    export default {
        name: 'adminIndex',
        data() {
            return {
                orderType:"",
                orderNumber:"",
                userId: '',
                infoObj:{
                    imageObj:{}
                },
                orderAdditionalMaterials:{},//补充资料
                payInfoStr:{},
                needInfomation:{},
                needProducerDo:{},
                needProcessingLink:{},
                specialProcess:{},
                deliveryInformation:{},
                contactInformationStr:{},
                shengchanAddressInfo:{},
                colorSizeData:[],
                fabricInformationStr:{
                	excipient:{}
                },
                addInfoObj:{
                    isShow:false
                },
                contactInfoObj:{},
                fadanfangObj:{
                    fadanfangInfo:{},
                    regStr:{
                        product:[],
                        channel: {
                            list: [],
                            typeId: ''
                        }
                    },
                },
                jiedanfangArr:[],
                isShowImgModal:false,
                currentPrevImg:'',

                // 订单进度
                jdOrderDynamics: [],
                fdOrderDynamics: [],

                // 查看合同
                seeContractShow: false,
                seeContract: {
                    contractRemarkImg: [],
                    contractRemark: '',
                    contractAdminRemark: ''
                },

                // 查看定金支付凭证
                seePayAdvanceVoucherShow: false,
                seePayAdvanceVoucher: {
                    paymentRemarkImg: [],
                    prepaymentRemark: '',
                    prepaymentAdminRemark: ''
                },

                // 查看大货
                seeGoodsShow: false,
                seeGoods: {
                    deliverDescription: '',
                    deliverQuantity: '',
                    deliverImg: [],
                    deliverLargeGoodsAdminRemark: ''
                },

                // 查看验收结果
                seeResultShow: false,
                seeResult: {
                    acceptanceImg: [],
                    description: '',
                    goodsTotal: '',
                    quantity: '',
                    rejectRatio: '',
                    submitAcceptanceResultsAdminRemark: ''
                },

                // 查看交货款支付凭证
                seePayDeliveryVoucherShow: false,
                seePayDeliveryVoucher: {
                    deliveryRemarkImg: [],
                    deliveryRemark: '',
                    deliveryAdminRemark:  ''
                },

                // 查看尾款支付凭证
                seePayTailVoucherShow: false,
                seePayTailVoucher: {
                    tailRemarkImg: [],
                    tailRemark: '',
                    tailAdminRemark: ''
                },

                // 查看评价
                seeCommentShow: false,
                seeComment: {
                    comment_score: 0,
                    comment_info: '',
                    producer_comment_score: 0,
                    producer_comment_info: '',
                },

                // 查看取消原因 (生产商取消)
                seeProducerCancelReasonShow: false,
                seeProducerCancelReason: {
                    producerCancelImg: [],
				    producerCancellationOfOrder: '',
                },

                // 查看补充资料
                seeAdditionalDataShow: false,
                seeAdditionalData: {
                    orderAdditionalMaterials: {},
                    technologyImg: [],
                    sizeTableImg: [],
                    checkGoodsImg: []
                },
                
                dialogVisible: false, // 图片review 弹框
                dialogImageUrl: '',  // 图片review 地址

            }
        },
        computed: {
            functionEditOrderProgress(){
                return utils.getCurrentFunction().indexOf("editOrderProgress")>-1
            },
        	IMG_PREV(){
        		return api.imgPrev
            },
            styleImgsArr() {
                let positive = [], negative = [], details = [];
                if (this.infoObj.imageObj && this.infoObj.imageObj.positiveImg) {
                    positive = this.infoObj.imageObj.positiveImg
                }
                if (this.infoObj.imageObj && this.infoObj.imageObj.negativeImg) {
                    negative = this.infoObj.imageObj.negativeImg
                }
                if (this.infoObj.imageObj && this.infoObj.imageObj.detailsImg) {
                    details = this.infoObj.imageObj.detailsImg
                }
                return positive.concat(negative).concat(details)
            }
        },
        methods: {
            prevImg(url){
            	this.isShowImgModal=true
            	this.currentPrevImg=url
            },
            toEditProgress() {
                this.$router.push({name: 'orderProgressEdit', params: {orderNumber: this.orderNumber}, query: {id: this.userId}})
            },
            formatData(str) {
            	let obj = {};
            	let requireObj = {
            		listStr: [],
            		other: ''
            	};
            	if (typeof str === 'string') {obj = JSON.parse(str)}
            	if (typeof str === 'object') {obj = str}
            	if (obj && obj.list && obj.list.length > 0) {
            		obj.list.forEach(item => {
            			if (item.isSelect == '1') {
            				requireObj.listStr.push(item.dataName);
            			}
            		})
            	}
            	if (obj && obj.other) {
            		requireObj.other = obj.other;
            	}
            	return requireObj;
            },
            back(){
            	this.$router.back()
            },
            toFadanDetail(){
                this.$router.push({ name: 'customerDetail', params: { userId:this.fadanfangObj.fadanfangInfo.user_id ,href:'fadanDetail'}})
                // this.$router.push({ name: 'brandCompanyDetail', params: {orderNumber:this.orderNumber,orderType:this.orderType}})
            },
            toJiedanDetail(list){
                this.$router.push({ name: 'customerDetail', params: { userId: list.user_id,href:'jiedanDetail' }})
                // this.$router.push({ name: 'factoryDetail', params: {  userId: list.user_id,orderNumber:this.orderNumber,orderType:this.orderType}})

            },
            getParam(){
            	this.orderNumber=this.$route.params.orderNumber
                this.orderType=this.$route.params.orderType
                this.userId = this.$route.query.id
            },
            getDetail_fabic(){//面辅料
                let _this=this
                let arg={
                    orderNumber:this.orderNumber,
                    orderType:this.orderType
                }
                ajaxPost('/admin/yijiajiaOrder/fabicInformation',arg).then(function(res){
                    //面辅料信息
                    if(res.data.fabricInformationStr){
                        _this.fabricInformationStr=res.data.fabricInformationStr
                    }
                    							 
                },function(res){
                    
                })
            },
            getDetail_addition(){
                let _this=this
                let arg={
                    orderNumber:this.orderNumber,
                    orderType:this.orderType
                }
                ajaxPost('/admin/yijiajiaOrder/additionalMaterialsShow',arg).then(function(res){
                    if(res.errorCode==200){
                         _this.addInfoObj.isShow=res.data.orderAdditionalMaterials.hasAdditionalMaterials
                        _this.addInfoObj.checkGoodsImg=res.data.orderAdditionalMaterialsPic.checkGoodsImg
                        _this.addInfoObj.sizeTableImg=res.data.orderAdditionalMaterialsPic.sizeTableImg
                        _this.addInfoObj.technologyImg=res.data.orderAdditionalMaterialsPic.technologyImg
                        _this.addInfoObj.additionalMaterialsRemark=res.data.orderAdditionalMaterials.additionalMaterialsRemark
                        _this.addInfoObj.inspectionMethod=res.data.orderAdditionalMaterials.inspectionMethod
                        _this.addInfoObj.manufacturerSelfTestRequirements=res.data.orderAdditionalMaterials.manufacturerSelfTestRequirements
                        _this.addInfoObj.proportionOfInspection=res.data.orderAdditionalMaterials.proportionOfInspection
                        _this.addInfoObj.qualityInspectionRequirements=res.data.orderAdditionalMaterials.qualityInspectionRequirements
                        _this.addInfoObj.selfTestMethod=res.data.orderAdditionalMaterials.selfTestMethod
                        _this.addInfoObj.thirdPartyInspectionRequirements=res.data.orderAdditionalMaterials.thirdPartyInspectionRequirements 
                    }
                   
                },function(res){
                    
                })
            },
            getDetail_info(){//部分详情
                let _this=this
                let arg={
                    orderNumber:this.orderNumber,
                    orderType:this.orderType
                }
                ajaxPost('/admin/yijiajiaOrder/orderDetailsShow',arg).then(function(res){
                    //基本信息
                     _this.infoObj=res.data?res.data:{} 
                     //图片信息：
                     if(_this.infoObj.imageJson){
                         _this.infoObj.imageObj=JSON.parse(_this.infoObj.imageJson)
                     }else{
                         _this.infoObj.imageObj={}
                     }
                     //支付信息
                    _this.payInfoStr=JSON.parse(res.data.payInfoStr);
                    _this.needInfomation = _this.formatData(res.data.needInfomation);
                    _this.needProducerDo =  _this.formatData(res.data.needProducerDo);
                    _this.needProcessingLink = _this.formatData(res.data.needProcessingLink);
                    _this.specialProcess = _this.formatData(res.data.specialProcess);
                    //交货信息:预计面辅料到齐时间，交货方式deliveryMethod，面辅料运费承担方，大货运费承担方
                    if(res.data.deliveryInformation){
                    	_this.deliveryInformation=JSON.parse(res.data.deliveryInformation) 
                    }
                    //联系方式
                    if(res.data.contactInformationStr){
                    	_this.contactInfoObj=res.data.contactInformationStr
                    }
                     if(res.data.shengchanAddressInfo){
                    	_this.shengchanAddressInfo=res.data.shengchanAddressInfo
                    }
                    
                    if(res.data.colorSizeQuantityStr){
                        _this.colorSizeGroup=JSON.parse(res.data.colorSizeQuantityStr)
                        let sizeArr=[]
                        _this.colorSizeGroup.group[0].sizeArr.forEach(function(item,index){
                            let buffer={name:item.name}
                            sizeArr.push(buffer)
                        })
                       let sizeCol=[{
                           color:"尺码",
                           sizeArr:sizeArr,
                           sum:"合计"
                       }]
                        _this.colorSizeData=sizeCol.concat(_this.colorSizeGroup.group)
                        console.log( _this.colorSizeData)
                       
                    }
                    console.log(_this.colorSizeGroup,"尺码颜色")
                    if(res.data.fadanfangInfo){
                        _this.fadanfangObj=res.data.fadanfangInfo
                    } 
                    if(res.data.jiedanfangInfo){
                        _this.jiedanfangArr=JSON.parse(res.data.jiedanfangInfo).jiedanfangInfo 
                        console.log( _this.jiedanfangArr,' _this.jiedanfangArr')
                    }
                     
                },function(res){
                    
                })
             
            },
            getFdOrderProgress() {
                let _this = this
                let arg = {
                    orderNumber: this.orderNumber,
                    userId: this.userId
                }
                ajaxApp('/yijiajiaOrder/orderProgressPinpai',arg).then(function(res){
                    console.log(res)
                    // res.data.orderDynamic
                    for(let i=0; i<res.data.orderDynamics.length; i++) {
                        let item=res.data.orderDynamics[i]
                        let buffer={}
                        buffer.record_time=item.record_time
                        console.log(item.log_text)
                        if (item.log_text.search("{")>-1) {
                                buffer.log_text=JSON.parse(item.log_text)
                        } else {
                            let textArr=[]
                            let textObj={
                                str:item.log_text
                            }
                            textArr.push(textObj)
                            let temp={
                                text:textArr
                            }
                            buffer.log_text=temp
                        }
                        if (item.log_text.lastIndexOf('。') > -1) {
                            buffer.isAdmin = true
                        } else {
                            buffer.isAdmin = false
                        }
                        _this.fdOrderDynamics.push(buffer);
                    }

                    if (res.data.info.order_status > 10300) {
                        _this.getJdOrderProgress({
                            orderNumber: _this.orderNumber,
                            userId: res.data.jiedanfang[0].user_id
                        })
                    }
                },function(err){
                    console.log(err)
                })

                
            },
            getJdOrderProgress(arg) {
                let _this = this
                ajaxApp('/yijiajiaOrder/orderProgressShengchan',arg).then(function(res){
                    console.log(res)
                    for(let i=0; i<res.data.orderDynamics.length; i++) {
                        let item=res.data.orderDynamics[i]
                        let buffer={}
                        buffer.record_time=item.record_time
                        console.log(item.log_text)
                        if (item.log_text.search("{")>-1) {
                                buffer.log_text=JSON.parse(item.log_text)
                        } else {
                            let textArr=[]
                            let textObj={
                                str:item.log_text
                            }
                            textArr.push(textObj)
                            let temp={
                                text:textArr
                            }
                            buffer.log_text=temp
                        }
                        if (item.log_text.lastIndexOf('。') > -1) {
                            buffer.isAdmin = true
                        } else {
                            buffer.isAdmin = false
                        }
                        _this.jdOrderDynamics.push(buffer);
                    }
                },function(err){
                    console.log(err)
                })
            },
            // 获取数据 -- 确认合同 / 确认定金支付凭证 / 确认交货款支付凭证
            checkInfo(flag) {
                if (flag === 'see_contract') {
                    this.seeContractShow = true;
                }

                if (flag === 'see_pay_advance_voucher') {
                    this.seePayAdvanceVoucherShow = true;
                }

                if (flag === 'see_goods') {
                    this.seeGoodsShow = true;
                }

                if (flag === 'see_pay_delivery_voucher') {
                    this.seePayDeliveryVoucherShow = true;
                }

                if (flag === 'see_pay_tail_voucher') {
                    this.seePayTailVoucherShow = true;
                }

                if (flag === 'see_comment') {
                    this.seeCommentShow = true;
                }

                if (flag === 'see_producer_cancel_reason') {
                    this.seeProducerCancelReasonShow = true;
                }
                
                ajaxApp('/yijiajiaOrder/paymentRemarkShow', {orderNumber: this.orderNumber}).then(res => {
                    console.log(res)
                    if (res.errorCode === 200) {
                        if (flag === 'see_contract') {
                           this.seeContract.contractRemarkImg = res.data.contractRemarkImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.seeContract.contractRemark = res.data.contractRemark
                            this.seeContract.contractAdminRemark = res.data.contractAdminRemark
                        }

                        if (flag === 'see_pay_advance_voucher') {
                            this.seePayAdvanceVoucher.paymentRemarkImg = res.data.paymentRemarkImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.seePayAdvanceVoucher.prepaymentRemark = res.data.prepaymentRemark
                            this.seePayAdvanceVoucher.prepaymentAdminRemark = res.data.prepaymentAdminRemark 
                        }

                        if (flag === 'see_goods') {
                            this.seeGoods.deliverImg = res.data.deliverImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.seeGoods.deliverDescription = res.data.deliverDescription
                            this.seeGoods.deliverQuantity = res.data.deliverQuantity
                            this.seeGoods.deliverLargeGoodsAdminRemark = res.data.deliverLargeGoodsAdminRemark 
                        } 
                        
                        if (flag === 'see_pay_delivery_voucher') {
                            this.seePayDeliveryVoucher.deliveryRemarkImg = res.data.deliveryRemarkImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.seePayDeliveryVoucher.deliveryRemark = res.data.deliveryRemark
                            this.seePayDeliveryVoucher.deliveryAdminRemark = res.data.deliveryAdminRemark
                            
                        }

                        if (flag === 'see_pay_tail_voucher') {
                            this.seePayTailVoucher.tailRemarkImg = res.data.tailRemarkImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.seePayTailVoucher.tailRemark = res.data.tailRemark
                            this.seePayTailVoucher.tailAdminRemark = res.data.tailAdminRemark
                        }

                        if (flag === 'see_comment') {
                            this.seeComment.comment_score = res.data.comment_score
                            this.seeComment.comment_info = res.data.comment_info
                            this.seeComment.producer_comment_score = res.data.producer_comment_score
                            this.seeComment.producer_comment_info = res.data.producer_comment_info
                        }

                        if (flag === 'see_producer_cancel_reason') {
                            this.seeProducerCancelReason.producerCancelImg = res.data.producerCancelImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                            this.seeProducerCancelReason.producerCancellationOfOrder = res.data.producerCancellationOfOrder
                        }
                    } 
                }, err => {
                    console.log(err)
                })
            },
            // 查看补充资料
			getAdditionalData () {
                this.seeAdditionalDataShow = true
                ajaxApp('/yijiajiaOrder/additionalMaterialsShow', { userId: this.userId, orderNumber: this.orderNumber, orderType: this.infoObj.orderType}).then(res => {
                    console.log(res)
                    if (res.errorCode === 200) {
                        this.seeAdditionalData.orderAdditionalMaterials = res.data.orderAdditionalMaterials ? res.data.orderAdditionalMaterials : {}
                        if (res.data.orderAdditionalMaterialsPic) {
                            if (res.data.orderAdditionalMaterialsPic.checkGoodsImg) {
                                this.seeAdditionalData.checkGoodsImg = res.data.orderAdditionalMaterialsPic.checkGoodsImg.map(item => {
                                    return  {
                                        ...item,
                                        image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                    }
                                })
                            }
                            if (res.data.orderAdditionalMaterialsPic.sizeTableImg) {
                                this.seeAdditionalData.sizeTableImg = res.data.orderAdditionalMaterialsPic.sizeTableImg.map(item => {
                                    return  {
                                        ...item,
                                        image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                    }
                                })
                            }
                            if (res.data.orderAdditionalMaterialsPic.technologyImg) {
                                this.seeAdditionalData.technologyImg = res.data.orderAdditionalMaterialsPic.technologyImg.map(item => {
                                    return  {
                                        ...item,
                                        image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                    }
                                })
                            }
                        }
                    } 
                }, err => {
                    console.log(err)
                }) 
			},
            // 查看验收结果
            seeResultData() {
                this.seeResultShow = true;
                ajaxApp('/yijiajiaOrder/confirmAcceptanceResultsshow', {orderNumber: this.orderNumber}).then(res => {
                    console.log(res)
                    if (res.errorCode === 200) {
                        if (res.data.acceptanceImg) {
                            this.seeResult.acceptanceImg = res.data.acceptanceImg.map(item => {
                                return {
                                    ...item,
                                    image_file: item.image_file ? this.IMG_PREV + item.image_file : ''
                                }
                            })
                        }
                        
                        this.seeResult.description = res.data.description
                        this.seeResult.goodsTotal = res.data.goodsTotal
                        this.seeResult.quantity = res.data.quantity
                        this.seeResult.rejectRatio = res.data.rejectRatio
                        this.seeResult.submitAcceptanceResultsAdminRemark = res.data.submitAcceptanceResultsAdminRemark
                    } 
                }, err => {
                    console.log(err)
                }) 
            },
            // 查看动态详情
            seeDynamicsDetail(link) {
                console.log(link)
				if(link=='补充详细资料'){
					this.getAdditionalData();
					return false;
				}
				if(link=='合同'){
					this.checkInfo('see_contract');
					return false;
				}
				if(link=='定金'){
                    this.checkInfo('see_pay_advance_voucher');
					return false;
				}
				if(link=='交货款'){
					this.checkInfo('see_pay_delivery_voucher');
					return false;
				}
				if(link=='尾款'){
					this.checkInfo('see_pay_tail_voucher');
					return false;
				}
				if(link=='评价'){
					this.checkInfo('see_comment')
					return false;
					
				}
			    if(link=='验收'){
				    this.seeResultData();
					return false;
			    }
				if(link=='大货'){//查看大货详情
					this.checkInfo('see_goods');
					return false;
				}
				if(link=='取消订单'){// 查看生产商取消原因
					this.checkInfo('see_producer_cancel_reason');
					return false;
				}
				if(link=='查看原因'){//查看原因
// 					this.toCheckCancelReason();
// 					return false;
                }
            },
            // 图片预览
            handlePictureCardPreview(file) {
                if (file.url) {
                    this.dialogImageUrl = file.url
                    this.dialogVisible = true
                }

                if (file.image_file) {
                    this.dialogImageUrl = file.image_file
                    this.dialogVisible = true
                }
                
                console.log(file)
            },
        },
        mounted() {
            let _this = this
            this.getParam()
            this.getDetail_info()
            this.getDetail_fabic()
            this.getDetail_addition()

            this.getFdOrderProgress()  // 获取订单进度

        }
    }
</script>

<style scoped lang="scss">
    // *{outline: 1px solid blue;}
    .orderDetail_wrap {
        //颜色尺码表格
        .sizeColorTable{ 
            display: flex;
            border-left:1px solid #F5F5F5;             border-bottom:1px solid #F5F5F5;           
            .tableCol{ 
               width: 90px; text-align: center;
               .colLabel{padding:10px 0;background: #FAFAFA;border-bottom: 1px solid #EAEAEA;}
               .num{padding:10px 0;border-bottom: 1px solid #F5F5F5;  font-size: 12px;}
               .total{padding:10px 0;font-weight: bold; font-size: 12px;}
            }
        }
        img{border:1px solid #ddd;}
        .itemSpan{margin-right: 5px;}
        .oneItem{
            .label{display: inline-block;color:#ababab; width:70px;letter-spacing: 1px; text-align: justify; text-align-last: justify;margin-right: 25px;}
            .text{display: inline-block;   vertical-align: top; 
                img{background:#f7f7f7;height: 100px;margin-right: 20px;}
            }
        }
        .oneItem.three{width: 33%;}
        .oneItem.two{width: 50%;}
        
        .brandFactoryPart{
            position: relative;
            .left{}
            .right{position: absolute;width: 100%;top:0;left:34%;
                .panelBox{width: 100%;}
            }
        }
        
        
        .content{
            color:#3d3d3d; 
            padding:0 20px;
            .panelBox{
                .panelTitle{
                    padding:28px 0 12px; font-size:17px; 
                    .inner{ border-left: 3px solid $lighterColor; line-height: 20px;padding-left:20px; position: relative;}
                    .edit-progress-btn { position: absolute; right: 0px; top: -10px;}
                }
                .panelContent{
                    background: #fff;padding:10px 20px;; font-size: 14px;
                }
                // 第一块
                .panelContent.first{
                    padding:20px;
                    .headerImg{
                        width:102px; height: 102px; background: #f2f2f2; 
                        img{max-height:100px;max-width: 100px;}
                    }
                    .rightBox{
                        flex:1; padding-left:20px;
                        .firstLine{ height: 40px; line-height: 40px;  position: relative;
                            .textBox{font-size: 14px;  width: 900px; }
                            .rightBox{ 
                                position: absolute;top:0;right:30px;
                                .rightButton{letter-spacing: 1px; font-size: 16px; box-shadow: 0 0 13px #ccd;}
                            }
                           
                        }
                        .normalLine{
                            line-height: 30px;
                            .oneItem{display: inline-block; width: 30%;
                                .label{display: inline-block;color:#ababab; width:70px; text-align: justify; text-align-last: justify;}
                                .text{display: inline-block;;}
                            }
                        }
                    }
                }
                // 第2块
                .panelContent.second{
                    background: none;padding:0 ;
                    .factoryWrap:nth-child(3n+0){margin-right: 0;}
                    .factoryWrap{
                        display: inline-block; width: 31%;margin-right:3%; 
                        .factoryTitle.active{background: $lighterColor;}
                        .factoryTitle{
                            height: 60px; line-height: 60px; background: #666; color:#fff;  padding:0 20px; position: relative;
                            font-size:14px;
                            .factoryIcon{width: 14px;height: 14px;}
                            .choseTag{
                                background: $lighterColor2; position: absolute;top:0;right:0;height: 6; padding:0 35px; color:#fff;
                            }
                            .choseTag:hover{cursor: pointer;background: $lightestColor}
                           
                        }
                        .factoryDetail{
                            padding:10px 20px; background: #fff;
                            .oneItem{padding:7px 0;
                                .text{max-width: 66%;}
                            }
                            
                        }
                    }
                }
               // 第3块
                .panelContent.third{
                    .line{display: flex;
                        .oneItem{padding:7px 0; .label{width: auto;}}
                        .oneItem.half{width: 40%;}
                    }
                    .line.last{padding:10px 0;border-top: 1px dotted #ddd;}
                    .heightLine{ 
                        .oneItem{flex:1;}
                        img{height: 100px; vertical-align: top; margin-right: 10px;}
                    }
                }
                 // 第4块
                .panelContent.fourth{
                    .oneBlock{
                        border-bottom: 1px solid #f2f2f2; padding:10px 0;
                        .blockTitle{ padding: 10px 0px;font-size: 14px;  }
                        .blockContent{
                            .label{width: auto;}
                            .line{ 
                                .oneItem{padding:5px 0;display: inline-block;}
                            }
                        }
                    }
                }

                // 订单进度
                .panelContent.progress {
                    display: flex;
                    .progress-item {
                        width: 50%;
                        padding-right: 40px;
                        .progress-item-title {
                            width: 80%;
                            height: 40px;
                            line-height: 40px;
                            margin-bottom: 20px;
                            span {
                                font-size: 18px;
                                margin-left: 10px;
                            }
                        }
                        span.active-text {
                            color: #2b87d6;
                            &:hover {
                                text-decoration: underline;
                                color: #0e85ea;
                                cursor: pointer;
                            }
                        }
                        .no-dynamics {
                            padding: 10px 0px 30px 40px;
                            color: #999;
                            font-size: 15px;
                        }
                    }
                }
                
                    
            }
        }
       
    }
    .el-rate {margin-top: 10px;}
    .admin-flag {margin-left: 10px;}
</style>



// WEBPACK FOOTER //
// src/pages/order/detail.vue